exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".snackbar__base {\n  background-color: #ff8c8c !important;\n  color: white !important; }\n\n.snackbar__action__btn {\n  background-color: white !important;\n  color: #ff8c8c !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Utility/Snackbars/index.scss
// module id = 1058
// module chunks = 1